import { render, staticRenderFns } from "./SessionLengthSetter.vue?vue&type=template&id=1552e51d&scoped=true"
import script from "./SessionLengthSetter.vue?vue&type=script&lang=js"
export * from "./SessionLengthSetter.vue?vue&type=script&lang=js"
import style0 from "./SessionLengthSetter.vue?vue&type=style&index=0&id=1552e51d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1552e51d",
  null
  
)

export default component.exports